import { AppDomainConfig } from "../../envConfig";
import { IndustryEnum } from "../../types/api-schema";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["ch"],
  font: '16px "Noto Sans"',
  iconCategories,
  id: "bernmobil", // needs to be identical to the icons directory name in public
  industry: IndustryEnum.Transport,
  name: "Bernmobil",
  pictures: [
    { id: "bernmobil_bus_v1.png" },
    { id: "bernmobil_doublebus_v1.png" },
    { id: "bernmobil_triplebus_v1.png" },
    { id: "bernmobil_tram_v1.png" },
    { id: "bernmobil_tram_long_v1.png" },
  ],
  previewBaselayers: true,
  slug: "svb",
  ...colors,
};
export default config;
